import script from "./AdminFatigueManageFormOptionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFatigueManageFormOptionsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminFatigueManageFormOptionsView.vue?vue&type=style&index=0&id=51e91988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e91988"]])

export default __exports__